$( () => {
    let swiperStory = new Swiper(".story-slider", {
        slidesPerView: 1,
        spaceBetween: 10,
        allowTouchMove: true, // Allow swipe navigation
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
    });

    const cardsStory = document.querySelectorAll('.card-story');
    let videos = document.querySelectorAll(".story-video");
    let playButtons = document.querySelectorAll(".toggleStory");
    let progressBars = document.querySelectorAll(".progress-bar");
    const sectionStory = document.getElementById('sectionStory');
    

    // Track which video is currently playing
    let activeIndex = swiperStory.activeIndex;
    let isPausedByUser = false;

    // Helper: reset all videos and progress bars
    function resetAll() {
        videos.forEach((video, index) => {
            video.pause();
            video.currentTime = 0;
            progressBars[index].style.width = "0%";
            progressBars[index].setAttribute("aria-valuenow", "0");
            playButtons[index].innerHTML = '<i class="fas fa-play"></i>';
        });
    }
    
    // Function to update progress bar
    function updateProgressBar() {
        const currentVideo = videos[activeIndex];
        const currentProgressBar = progressBars[activeIndex];

        if (!currentVideo || !currentProgressBar) return;

        // Set previous progress bars to 100%
        progressBars.forEach((bar, index) => {
            bar.style.width = index < activeIndex ? "100%" : "0%";
            bar.setAttribute("aria-valuenow", index < activeIndex ? "100" : "0");
        });

        function step() {
            if (!currentVideo.paused && !currentVideo.ended) {
                const progress = (currentVideo.currentTime / currentVideo.duration) * 100;
                currentProgressBar.style.width = `${progress}%`;
                currentProgressBar.setAttribute("aria-valuenow", progress.toFixed(2));
                requestAnimationFrame(step);
            }
        }

        requestAnimationFrame(step);
    }

    // Toggle play/pause
    function togglePlay(video, button) {
        if (video.paused) {
            isPausedByUser = false;
            video.play();
            button.innerHTML = '<i class="fas fa-pause"></i>';
        } else {
            isPausedByUser = true;
            video.pause();
            button.innerHTML = '<i class="fas fa-play"></i>';
        }
    }

    // On button click, toggle video
    playButtons.forEach((button, index) => {
        button.addEventListener("click", () => {
            togglePlay(videos[index], button);
        });
    });

    // Handle slide change
    swiperStory.on("slideChange", () => {
        resetAll(); // stop all
        activeIndex = swiperStory.activeIndex;
        if (!isPausedByUser) {
            videos[activeIndex].play();
            playButtons[activeIndex].innerHTML = '<i class="fas fa-pause"></i>';
        }
    });

    // Autoplay + Progress tracking when video plays
    videos.forEach((video, index) => {
        video.addEventListener("play", () => {
            activeIndex = index;
            isPausedByUser = false;
            updateProgressBar(video, progressBars[index]);
        });

        video.addEventListener("ended", () => {
            swiperStory.slideNext(); // go to next story
        });
    });

    // Add event listeners to all toggleSound buttons
    document.querySelectorAll('.toggleSound').forEach((btn, index) => {
        btn.addEventListener('click', function () {
            const icon = btn.querySelector('i');
    
            // Determine if we're unmuting (based on first video)
            const shouldUnmute = videos[0].muted;
    
            // Toggle mute on all videos
            videos.forEach(video => {
                video.muted = !shouldUnmute;
            });
    
            // Update icon on all toggleSound buttons
            document.querySelectorAll('.toggleSound i').forEach(iconEl => {
                iconEl.classList.toggle('fa-volume-up', shouldUnmute);
                iconEl.classList.toggle('fa-volume-mute', !shouldUnmute);
            });
        });
    });

    document.querySelectorAll('.card-touch').forEach((layer) => {
        layer.addEventListener("click", (e) => {
            const rect = layer.getBoundingClientRect();
            const x = e.clientX - rect.left;
            const width = rect.width;
    
            if (x < width / 3) {
                if (swiperStory.activeIndex > 0) {
                    swiperStory.slidePrev();
                }
            } else if (x > (2 * width) / 3) {
                if (swiperStory.activeIndex < cardsStory.length - 1) {
                    swiperStory.slideNext();
                }
            } else {
                const video = videos[activeIndex];
                const button = playButtons[activeIndex];
                togglePlay(video, button);
            }
        });
    });

    // Intersection observer setup
    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            const activeVideo = videos[activeIndex];
            const activeCard = cardsStory[activeIndex];
            const playButton = activeCard && activeCard.querySelector('.toggleStory');
    
            if (!activeVideo || !playButton) return;
    
            if (!entry.isIntersecting) {
                // Pause video only if it’s not already paused
                if (!activeVideo.paused) {
                    togglePlay(activeVideo, playButton);
                }
            } else {
                // Resume only if the user didn’t manually pause
                if (activeVideo.paused && !activeVideo.ended && !isPausedByUser) {
                    togglePlay(activeVideo, playButton);
                }
            }
        });
    }, {
        threshold: 0.1 // trigger when 10% or less of the section is visible
    });

    if (sectionStory) {
        observer.observe(sectionStory);
    }

    // Start autoplay when page loads
    window.addEventListener("load", () => {
        videos[activeIndex].play();
        playButtons[activeIndex].innerHTML = '<i class="fas fa-pause"></i>';
    });

    // Add active class to liked videos on page load
    let likedVideos = JSON.parse(localStorage.getItem("likedVideos")) || [];
    likedVideos.forEach(id => {
        $('.video-fav-' + id).addClass('active');
    });

    $(document).on("click", ".video-fav-btn", function (e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        
        var id = $(this).data('id');

        let likedVideos = JSON.parse(localStorage.getItem("likedVideos")) || [];
        if (likedVideos.includes(id)) {
            // console.log("You have already liked this video.");
            return;
        }

        var values = '_token=' + $("meta[name='csrf-token']").attr("content");
        values += '&id=' + id;
        $.ajax({
            type: "POST",
            url: baseURL + "/videos/like",
            data: values,
            success: function(response) {
                if (response.status == 1) {
                    $('.video-fav-' + id).addClass('active');
                    $('.video-fav-' + id + ' span').html(response.data.favorites);

                    // Save the video ID to local storage
                    likedVideos.push(id);
                    localStorage.setItem("likedVideos", JSON.stringify(likedVideos));
                }
            },
            error: function() {
                // Handle error
            }
        });
    });

    let videosForViews = document.querySelectorAll(".video-element");
    let viewedVideos = JSON.parse(localStorage.getItem("viewedVideos")) || [];

    videosForViews.forEach((video) => {
        video.addEventListener("play", function () {
            var id = $(this).data('id');

            // Check if the video has already been viewed
            if (viewedVideos.includes(id)) {
                // console.log("View already recorded for video ID:", id);
                return;
            }

            var values = '_token=' + $("meta[name='csrf-token']").attr("content");
            values += '&id=' + id;
            $.ajax({
                type: "POST",
                url: baseURL + "/videos/view",
                data: values,
                success: function(response) {
                    if (response.status == 1) {
                        // console.log("View count updated for video ID:", id);
                        $('.video-view-' + id + ' span').html(response.data.views);

                        // Save the video ID to local storage
                        viewedVideos.push(id);
                        localStorage.setItem("viewedVideos", JSON.stringify(viewedVideos));
                    }
                },
                error: function() {
                    console.error("Failed to update view count for video ID:", id);
                }
            });
        });
    });
});



// WEBPACK FOOTER //
// ./resources/assets/js/modules/story.js